import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/22_card_back_sakura/22_card_back_sakura"
 * Contains 1 texture(s)
 */
export class CardsBacks22CardBackSakuraAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/22_card_back_sakura/22_card_back_sakura';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '22_sakura.png'
    ] as const;
}
